import API from './api'

export const register = async (body) => {
  try {
    const response = await API.post(`/Login/register`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const checkLogin = async (body) => {
  try {
    const response = await API.post(`/Login/check`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const saveProfile = async (body) => {
  try {
    const response = await API.post(`/User/profile`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const switchProfile = async (key) => {
  try {
    const response = await API.post(`/User/switchprofile/${key}`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const refreshToken = async () => {
  try {
    const response = await API.get(`/User/refreshtoken`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const setUserInfo = (result) => {
  window.localStorage.setItem('token', result.token)
  window.sessionStorage.setItem('activeAccountInfo', JSON.stringify(result?.profiles?.[0]) || '')
  window.sessionStorage.setItem('accounts', JSON.stringify(result?.profiles) || '')
}

export const removeUserInfo = () => {
  window.sessionStorage.removeItem('accounts')
  window.sessionStorage.removeItem('activeAccountInfo')
  window.localStorage.removeItem('token')
  window.localStorage.setItem('logout-event', Date.now().toString())
}

export const getProfile = async () => {
  try {
    const response = await API.get(`/user/profile`)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const updateProfile = async (body) => {
  try {
    const response = await API.put(`/user/profile`, body)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}

export const uploadProfileImage = async (formData) => {
  try {
    const response = await API.put(`/User/profile/icon`, formData)
    return response.data
  } catch (error) {
    return error.response ? error.response.data : error
  }
}
